module.exports = __webpack_public_path__ + "img/2020.2.8055c58f.jpg";